<template>
	<div class="relative z-10 !mb-0">
		<button
			type="button"
			@mouseover="show = true"
			@mouseleave="show = false"
			@click="onAddRemoveButtonClick"
			:class="['group/wishlistactions absolute', positionClasses]"
			aria-label="Add or remove from wishlist"
		>
			<span class="absolute -top-1 -right-1 sm:top-2 sm:right-0">
				<svg
					v-if="productsInAnyWishlist()"
					xmlns="http://www.w3.org/2000/svg"
					class="h-4 w-4 sm:h-5 sm:w-5"
				>
					<use :href="iconHref('HeartIconBlue')" />
				</svg>
				<svg v-else xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-5 sm:w-5">
					<use
						:href="iconHref('HeartIconOutlined')"
						class="group-hover/wishlistactions:hidden"
					/>
					<use
						:href="iconHref('HeartIconBlue')"
						class="hidden group-hover/wishlistactions:block"
					/>
				</svg>
			</span>

			<span
				v-if="show"
				class="relative right-8 block rounded-sm bg-white py-1 px-4 shadow-md"
			>
				<span class="mr-1 text-xs text-blue hover:text-black">Add | Remove</span>
			</span>
		</button>
	</div>
</template>

<script>
import { mapActions } from "pinia"
import { useWishlistStore } from "../../stores/wishlist"

import ProductQuantityUtil from "../wishlists/utils/product-quantity"

import EventBus from "../../bus"
import Events from "../wishlists/events"

import HeartIconBlue from "../../../assets/icons/heart-icon-fill.svg"
import HeartIconOutlined from "../../../assets/icons/heart-icon-outline.svg"

const iconMap = {
	HeartIconBlue: HeartIconBlue,
	HeartIconOutlined: HeartIconOutlined,
}

export default {
	name: "IntWishlistActions",

	props: {
		productIds: { type: Array, required: true },
		collectionId: { type: Number, default: 0 },
		quantity: {
			type: Number,
			default: 1,
			validator: (value) => {
				return value !== null && value !== undefined && value !== "" && value > 0
			},
		},
		positionClasses: { type: String, default: "top-0 right-0" },
	},

	data() {
		return {
			show: false,
		}
	},

	methods: {
		...mapActions(useWishlistStore, ["anyWishlistHasAllProducts"]),

		iconHref(key) {
			if (iconMap[key]) return "#" + iconMap[key].id
			return null
		},

		onAddRemoveButtonClick() {
			const productsEvent = ProductQuantityUtil.createProductQuantityEvent(
				this.productIds,
				this.collectionId,
				this.quantity,
			)
			EventBus.$emit(Events.addOrRemoveProducts, productsEvent)
		},

		productsInAnyWishlist() {
			return this.anyWishlistHasAllProducts(this.productIds)
		},
	},
}
</script>
